<template>
    <article>
    <section class="relative bg-white self-gutter-y rounded-b-2xl">
        <div class="self-gutter">
            <div class="pb-48 self-content-sm">
                <ReportNavigation/>

                <div class="flex flex-wrap w-full">
                    <div class="order-2 w-full sm:order-1 sm:w-2/3">
                        <h1 class="mb-24 sm:mb-48 title-2xl">{{ $t('about.title') }}</h1>
                        <div class="self-min-h-content self-body-text self-body-text--md" v-html="externalHTML">
                        </div>
                    </div>
                    <!-- SIDE NAVBAR -->
                    <div class="relative order-1 w-full pb-48 sm:pb-0 sm:order-2 sm:w-1/3 sm:pl-48">
                        <div class="self-sidemenu">
                            <ul class="extra-content-page-nav">
                                <li><a href="#overview" class="block pt-16 text-primary self-animate hover:underline" >{{ $t('about.nav.overview') }}</a></li>
                                <li><a href="#invoiceReports" class="block pt-16 text-primary self-animate hover:underline" >{{ $t('about.nav.invoice_reports') }}</a></li>
                                <li><a href="#serviceReports" class="block pt-16 text-primary self-animate hover:underline" >{{ $t('about.nav.service_reports') }}</a></li>
                                <li><a href="#passengerReports" class="block pt-16 text-primary self-animate hover:underline" >{{ $t('about.nav.passenger_reports') }}</a></li>
                                <li><a href="#travelsReports" class="block pt-16 text-primary self-animate hover:underline" >{{ $t('about.nav.travels_report') }}</a></li>
                                <!--                                <li><a href="#co2Reports" class="block pt-16 text-primary self-animate hover:underline" v-html="$t('about.nav.co2_reports')"></a></li>-->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </article>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import LogoIllustrationSVG from '@/assets/static/icons-src/logo-illustration.svg'
import axios from 'axios';
import config from '../../config.js';
import ReportNavigation from '@/components/ReportNavigation.vue'
@Component({
    components: {
        ReportNavigation,
        LogoIllustrationSVG
    },
    metaInfo: {
        title: 'About'
    }
})
export default class AboutView extends Vue {
    private externalHTML = ''

    private baseUrl = config.VUE_APP_ABOUT_PAGE_HTML_BASE_URL
    async fetchExternalHTML () {
        try {
            const url = this.baseUrl + "info" + "_" + this.$i18n.locale + ".html"
            axios.get(url)
                .then(response => {
                    this.externalHTML = response.data
                })
                .catch(error => {
                    console.error('GET request error:', error)
                })
        } catch (error) {
            console.error("Error fetching external HTML template", error);
        }
    }

    mounted() {
        this.fetchExternalHTML();
    }

    @Watch('$i18n.locale')
    async onLocaleChange() {
        await this.fetchExternalHTML();
    }
}
</script>

<style scoped>
</style>
